import { ListTicket, Ticket, TicketStatus } from 'src/store/models/Ticket';

export const formatListTicket = (ticket: Ticket): ListTicket => {
  return {
    id: ticket.id,
    ticketId: getTicketId(ticket.prefix, ticket.id),
    prefix: ticket.prefix,
    status: ticket.status,
    unitId: ticket.unitId,
    model: ticket.model,
    assignedAt: ticket?.assignedAt,
    createdAt: ticket.createdAt,
    startedAt: ticket.startedAt,
    resolvedAt: ticket.resolvedAt,
    address: ticket.user?.address,
    owner: ticket.user?.title,
    assignee: ticket?.assignee,
    lat: ticket.user?.lat,
    lon: ticket.user?.lon,
  };
};

export const formatListTickets = (tickets: Ticket[]): ListTicket[] => {
  return tickets?.map((ticket) => {
    return formatListTicket(ticket);
  });
};

export const getTicketId = (prefix: string, id: number): string => {
  return `${prefix}_${id}`;
};

export const sortByTicketStatus = (a: ListTicket, b: ListTicket): number => {
  const map = {
    [TicketStatus.UNASSIGNED]: 0,
    [TicketStatus.TO_DO]: 1,
    [TicketStatus.IN_PROGRESS]: 2,
    [TicketStatus.RESOLVED]: 3,
  };

  /* Sort by status */
  if (map[a?.status] > map[b?.status]) return -1;
  if (map[a?.status] < map[b?.status]) return 1;

  /* Unassigned sort by createdAt */
  if (map[a?.status] === 0 && map[b?.status] === 0) {
    return new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime();
  }
  /* Assigned sort by assignedAt */
  if (map[a?.status] === 1 && map[b?.status] === 1) {
    return (
      new Date(b?.assignedAt).getTime() - new Date(a?.assignedAt).getTime()
    );
  }
  /* In-progress sort by startedAt */
  if (map[a?.status] === 2 && map[b?.status] === 2) {
    return new Date(b?.startedAt).getTime() - new Date(a?.startedAt).getTime();
  }
  /* Resolved sort by resolvedAt */
  if (map[a?.status] === 3 && map[b?.status] === 3) {
    return (
      new Date(a?.resolvedAt).getTime() - new Date(b?.resolvedAt).getTime()
    );
  }
};

export const getTicketSortingDate = (
  status: TicketStatus
): keyof ListTicket => {
  switch (status) {
    case TicketStatus.UNASSIGNED:
      return 'createdAt';
    case TicketStatus.TO_DO:
      return 'assignedAt';
    case TicketStatus.IN_PROGRESS:
      return 'startedAt';
    case TicketStatus.RESOLVED:
      return 'resolvedAt';
  }
};
